import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { learningAPI } from '../services/api';
import { useProfile } from '../context/ProfileContext';

export default function LearningScreen() {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadModules();
  }, []);

  const loadModules = async () => {
    try {
      if (profile) {
        const progress = await learningAPI.getProgress(profile.id);
        setModules(progress);
      } else {
        const mods = await learningAPI.getModules();
        setModules(mods.map(m => ({ ...m, completedCount: 0, percentComplete: 0 })));
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const MODULE_COLORS = {
    animals: { bg: '#FFF3E0', color: '#FF9F43', gradient: 'linear-gradient(135deg, #FF9F43, #FF6B35)' },
    space: { bg: '#EDE7F6', color: '#7B1FA2', gradient: 'linear-gradient(135deg, #5F27CD, #341f97)' },
    language: { bg: '#E8F5E9', color: '#2E7D32', gradient: 'linear-gradient(135deg, #26de81, #20bf6b)' }
  };

  return (
    <div className="screen">
      <div className="screen-header" style={{ background: 'linear-gradient(135deg, #26de81, #20bf6b)', paddingBottom: 16 }}>
        <button className="btn-back" onClick={() => navigate('/')} style={{ background: 'rgba(255,255,255,0.3)', color: 'white' }}>←</button>
        <div>
          <h1 style={{ fontFamily: 'var(--font-title)', color: 'white', fontSize: '1.5rem' }}>🔭 Learn</h1>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.8rem' }}>Discover amazing things!</p>
        </div>
      </div>

      <div className="screen-body" style={{ paddingTop: 20 }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <div className="spinner" style={{ margin: '0 auto' }} />
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {modules.map(module => {
              const colors = MODULE_COLORS[module.id] || { bg: '#F5F5F5', color: '#666', gradient: 'linear-gradient(135deg, #666, #999)' };
              return (
                <div
                  key={module.id}
                  className="card card-clickable"
                  onClick={() => navigate(`/learning/${module.id}/intro`)}
                  style={{ padding: 0, overflow: 'hidden' }}
                >
                  {/* Header */}
                  <div style={{ background: colors.gradient, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ fontSize: '2.5rem' }}>{module.icon}</div>
                    <div>
                      <div style={{ fontFamily: 'var(--font-title)', color: 'white', fontSize: '1.1rem' }}>{module.name}</div>
                      <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.8rem' }}>{module.lessonCount} lessons</div>
                    </div>
                  </div>

                  {/* Progress */}
                  <div style={{ padding: '12px 20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', fontWeight: 700, marginBottom: 6, color: 'var(--gray)' }}>
                      <span>Progress</span>
                      <span>{module.completedCount || 0}/{module.lessonCount} completed</span>
                    </div>
                    <div className="progress-bar">
                      <div className="progress-bar-fill" style={{ width: `${module.percentComplete || 0}%` }} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="card" style={{ background: '#FFF9E6', border: '2px solid var(--yellow)' }}>
          <div style={{ fontWeight: 800, marginBottom: 4 }}>🎓 Learn & Earn</div>
          <div style={{ color: 'var(--gray)', fontSize: '0.85rem' }}>Complete lessons to earn <strong>+8 points</strong> each!</div>
        </div>
      </div>
    </div>
  );
}
